/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_LocalInputs */



/**
* | output |
* | --- |
* | "Local event" |
*
* @param {Tournament_Wiz_Kind_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_local = /** @type {((inputs?: Tournament_Wiz_Kind_LocalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_LocalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événement local")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento local")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Evento local")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento locale")
	return /** @type {LocalizedString} */ ("Local event")
});